export default "__VITE_ASSET__UVwP5wQq__"